// extracted by mini-css-extract-plugin
module.exports = {"styles":"styles___1zOsv","uploadContainer":"uploadContainer___3S5rl"};